{
  "it": {
    "validations": {
      "required": "Il campo %{field} è obbligatorio",
      "min": "Il campo %{field} deve avere almeno %{min} caratteri",
      "max": "Il campo %{field} deve avere al massimo %{max} caratteri",
      "alpha_dash": "The %{field} field may contain alpha-numeric characters as well as dashes and underscores",
      "email": "Il campo %{field} deve essere un indirizzo e-mail valido",
      "confirmed": "Il campo %{field} non corrisponde",
      "numeric": "Il campo %{field} può contenere solo caratteri numerici",
      "between": "Il campo %{field} deve essere tra %{min} e %{max}",
      "min_value": "Il campo %{field} deve essere %{min} o più",
      "url": "Il campo %{field} non è un URL valido"
    }
  }
}
